// src/api/pay.js
// import axios from "axios";
import http from '../api/axios';
const API_BASE = "https://api.xibaba888.com"; // 替换成你的后端接口地址
// 支付状态映射
const STATUS_MAP = {
  created: "WAITING",
  paid: "PAID",
  expired: "EXPIRED",
};
/**
 * 下单接口
 * @param {Object} params - 订单参数 { amount, pay_type, method, ... }
 * @returns {Promise<{ success: boolean, orderId: string|null, qrcode: string|null, payUrl: string|null, message: string }>}
 */
export function pay(params) {
  return http
    .post(API_BASE + "/api/pay/unifiedorder", params)
    .then((res) => {
      const data = res.data || {};
      if (!data || data.code !== 1) {
        return {
          success: false,
          orderId: null,
          qrcode: null,
          payUrl: null,
          message: data.msg || "订单创建失败",
        };
      }

      return {
        success: true,
        orderId: data.orderid || (data.data && data.data.orderid),
        qrcode: data.data && data.data.code_url, // 微信扫码
        payUrl: data.data && data.data.pay_url, // H5 / 支付宝跳转
        message: "下单成功",
      };
    })
    .catch((err) => {
      console.error("支付下单失败:", err);
      return {
        success: false,
        orderId: null,
        qrcode: null,
        payUrl: null,
        message: "网络错误，请稍后再试",
      };
    });
}

/**
 * 查询支付状态
 * @param {string} orderId - 订单号
 * @returns {Promise<{ success: boolean, status: string, message: string }>}
 */
export async function checkStatus(orderId) {
  try {
    const res = await http.post(API_BASE + "/api/pay/query", { orderid: orderId });
    const data = res.data || {};
    if (data.code === 1 && data.status) {
      return {
        success: true,
        status: STATUS_MAP[data.status] || "FAIL",
        message: "查询成功",
      };
    }
    return { success: false, status: "FAIL", message: data.msg || "查询失败" };
  } catch (err) {
    console.error("查询支付状态失败:", err);
    return { success: false, status: "FAIL", message: "网络错误" };
  }
}



// WEBPACK FOOTER //
// ./src/api/pay.js